import React, { ReactElement } from 'react';
import { TNamespaceEnum } from 'types/types';
import { getTranslation, useTranslation } from 'utils/localization';
import styles from './PasswordHelp.module.scss';

interface Props {
    password: string;
}

const PasswordHelp = ({ password }: Props): ReactElement => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={styles.passwordFormatTitle}>
                <span>
                    {getTranslation(
                        t,
                        TNamespaceEnum.signup,
                        'passwordHelpTitle'
                    )}
                </span>
            </div>
            <div>
                {getTranslation(
                    t,
                    TNamespaceEnum.signup,
                    'passwordMustContain'
                )}
                <ul className={styles.passwordRequirementList}>
                    <li
                        className={
                            password.length < 8 ? '' : styles.requirementPassed
                        }
                    >
                        {getTranslation(
                            t,
                            TNamespaceEnum.signup,
                            'passLengthAtLeast'
                        )}
                    </li>
                    <li
                        className={
                            /[a-z]/.test(password)
                                ? styles.requirementPassed
                                : ''
                        }
                    >
                        {getTranslation(
                            t,
                            TNamespaceEnum.signup,
                            'oneSmallLetter'
                        )}
                    </li>
                    <li
                        className={
                            /[A-Z]/.test(password)
                                ? styles.requirementPassed
                                : ''
                        }
                    >
                        {getTranslation(
                            t,
                            TNamespaceEnum.signup,
                            'oneBigLetter'
                        )}
                    </li>
                    <li
                        className={
                            /[0-9]/.test(password)
                                ? styles.requirementPassed
                                : ''
                        }
                    >
                        {getTranslation(t, TNamespaceEnum.signup, 'oneNumber')}
                    </li>
                    <li
                        className={
                            /[\W|_]/.test(password)
                                ? styles.requirementPassed
                                : ''
                        }
                    >
                        {getTranslation(
                            t,
                            TNamespaceEnum.signup,
                            'oneSpecialChar'
                        )}
                    </li>
                    <li
                        className={
                            /[À-ž]/.test(password)
                                ? ''
                                : styles.requirementPassed
                        }
                    >
                        {getTranslation(
                            t,
                            TNamespaceEnum.signup,
                            'noDiacritics'
                        )}
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default PasswordHelp;
